import { IRoute } from 'types/common';
import rootRoutes from './root/routes';

const routes: IRoute[] = [
  ...rootRoutes,
];

export default routes;
